/*
  Clubs column in the Pro Clubs mega menu. Desktop: every country column is followed by a collapsed
  "Clubs" column. Hovering or focusing a league opens that column to the width of the league's club list
  and the columns to the right move along; another league swaps the list, a league in another country
  closes the first column and opens the next. The first league is open by default and the panel
  returns to it once the pointer has left both the league and the column. Drawer: the chevron next to a league folds its club list open inline.
*/
(function () {
  var DESKTOP = window.matchMedia('(min-width: 1024px)');
  var INTENT_MS = 90;
  var LEAVE_MS = 240;

  function setup(mega) {
    var columns = Array.prototype.slice.call(mega.querySelectorAll('[data-club-panes]'));
    if (!columns.length) return;
    var leagues = Array.prototype.slice.call(mega.querySelectorAll('.submenu__item--league'));
    var currentLeague = null;
    var intentTimer = null;
    var leaveTimer = null;

    var list = columns[0].parentElement;
    var inner = list.parentElement;

    // Centre the closed row once per opening; the open columns then grow to the right from there.
    function anchor() {
      if (!DESKTOP.matches || currentLeague) return;
      list.style.setProperty('--list-offset', '0px');
      var offset = Math.max(0, (inner.clientWidth - list.offsetWidth) / 2);
      list.style.setProperty('--list-offset', Math.round(offset) + 'px');
    }
    window.addEventListener('resize', anchor);

    function columnFor(league) {
      var country = league.closest('.submenu__item--parent');
      var next = country && country.nextElementSibling;
      return next && next.hasAttribute('data-club-panes') ? next : null;
    }

    function open(league) {
      var column = columnFor(league);
      var id = league.getAttribute('data-league');
      clearTimeout(leaveTimer);
      if (!column) return;
      if (league === currentLeague) return;

      columns.forEach(function (other) {
        if (other !== column) close(other);
      });

      var panes = column.querySelectorAll('[data-league-pane]');
      Array.prototype.forEach.call(panes, function (pane) {
        pane.hidden = pane.getAttribute('data-league-pane') !== id;
      });
      leagues.forEach(function (item) {
        item.classList.toggle('is-current', item === league);
      });

      var inner = column.querySelector('.submenu__clubs-inner');
      column.style.setProperty('--w', inner.offsetWidth + 'px');
      column.style.setProperty('--line-top', Math.round(league.getBoundingClientRect().bottom - column.getBoundingClientRect().top + 2) + 'px');
      column.classList.add('is-open');
      column.setAttribute('aria-hidden', 'false');
      column.previousElementSibling.classList.add('is-expanded');
      currentLeague = league;
    }

    function close(column) {
      column.classList.remove('is-open');
      column.setAttribute('aria-hidden', 'true');
      column.previousElementSibling.classList.remove('is-expanded');
    }

    function closeAll() {
      columns.forEach(close);
      leagues.forEach(function (item) {
        item.classList.remove('is-current');
      });
      currentLeague = null;
    }

    // Default state: the first league (1. Bundesliga) is open whenever the panel shows and after the
    // pointer has left the leagues and columns.
    function openDefault() {
      if (leagues.length && DESKTOP.matches) open(leagues[0]);
    }

    function scheduleClose() {
      clearTimeout(leaveTimer);
      leaveTimer = setTimeout(openDefault, LEAVE_MS);
    }

    leagues.forEach(function (league) {
      var link = league.querySelector('[data-league-link]');
      league.addEventListener('mouseenter', function () {
        if (!DESKTOP.matches) return;
        clearTimeout(intentTimer);
        clearTimeout(leaveTimer);
        intentTimer = setTimeout(function () {
          open(league);
        }, currentLeague ? INTENT_MS : 0);
      });
      league.addEventListener('mouseleave', function () {
        if (!DESKTOP.matches) return;
        clearTimeout(intentTimer);
        scheduleClose();
      });
      if (link) {
        link.addEventListener('focus', function () {
          if (DESKTOP.matches) open(league);
        });
      }
    });

    columns.forEach(function (column) {
      column.addEventListener('mouseenter', function () {
        clearTimeout(leaveTimer);
      });
      column.addEventListener('mouseleave', function () {
        if (DESKTOP.matches) scheduleClose();
      });
      column.addEventListener('focusin', function () {
        clearTimeout(leaveTimer);
      });
      column.addEventListener('focusout', function (event) {
        if (!column.contains(event.relatedTarget)) scheduleClose();
      });
    });

    // Reset when the mega menu closes, so the next opening starts collapsed.
    var observer = new MutationObserver(function () {
      if (!mega.classList.contains('is-open') && !mega.classList.contains('is-opening')) {
        clearTimeout(intentTimer);
        clearTimeout(leaveTimer);
        closeAll();
      } else {
        anchor();
        openDefault();
      }
    });
    anchor();
    observer.observe(mega, { attributes: true, attributeFilter: ['class'] });

    mega.querySelectorAll('.submenu__club-toggle').forEach(function (button) {
      button.addEventListener('click', function () {
        var list = document.getElementById(button.getAttribute('aria-controls'));
        if (!list) return;
        var expanded = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        list.hidden = expanded;
      });
    });
  }

  function init() {
    document.querySelectorAll('.submenu--club-panel').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
